import { FC } from "react";

interface IProps {
  currentPath?: string;
  currentId?: string;
  item: any;
  onSelect?: Function;
}

export const ExplorerItem: FC<IProps> = ({
  item,
  onSelect,
  currentPath,
  currentId,
}) => {
  const sizeHuman = !!item.size ? bytesToLargestUnit(item.size) : "";

  const classes = ["explorer-list-item", item.type.toLowerCase()];

  if (item.parsing) {
    classes.push("parsing");
  } else {
    classes.push("ext_" + item.name.split(".").pop());
  }
  if (item.selected) classes.push("selected");

  const handleClick = (path: string, uuid: string) =>
    onSelect && onSelect(path, uuid);

  return (
    <li
      className={classes.join(" ")}
      data-id={item.id}
      onClick={() =>
        item.type === "FOLDER"
          ? handleClick(
              currentPath + "/" + item.name,
              currentId + "/" + item.id
            )
          : undefined
      }
    >
      <div className="explorer-column" style={{ flexBasis: "30%" }}>
        {item.secondaryIcon && (
          <i className={"secondary-icon " + item.secondaryIcon} />
        )}
        <span
          className={
            item.type === "FOLDER"
              ? "explorer-item-link explorer-item-link-name"
              : ""
          }
          title={item.name}
        >
          {item.name}
        </span>
      </div>
      <div
        className="explorer-column"
        style={{ width: 90 }}
        title={item.contentType}
      >
        {getFileExtension(item.name)}
      </div>
      <div
        className="explorer-column"
        style={{ width: 100 }}
        title={item.size ? item.size + " bytes" : undefined}
      >
        {sizeHuman}
      </div>
    </li>
  );
};

const bytesToLargestUnit = (bytes: number, precision = 2) => {
  const units = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  if (+bytes === 0) return `0 ${units[0]}`;

  const kilobyte = 1024;
  const exponent = Math.min(
    Math.floor(Math.log(bytes) / Math.log(kilobyte)),
    units.length - 1
  );
  const convertedValue = (bytes / Math.pow(kilobyte, exponent)).toFixed(
    precision
  );
  const unit = units[exponent];

  return `${convertedValue} ${unit}`;
};

const getFileExtension = (filename: string) => {
  return filename.slice(((filename.lastIndexOf(".") - 1) >>> 0) + 2);
};
